import {Component, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {CatalogService} from '@service/catalog/catalog.service';
import {HeaderStep} from '@enum/header.step';
import {HeaderService} from '@service/header/header.service';
import {CommonService} from '@service/common/common.service';
import {takeUntil} from 'rxjs/operators';
import {Subject} from 'rxjs';
import {OrderService} from '@service/order/order.service';
import {NavigationService} from '@service/navigation/navigation.service';

@Component({
    selector: 'app-catalog-index',
    templateUrl: './catalog-index.component.html',
    styleUrls: ['./catalog-index.component.scss'],
    standalone: false
})
export class CatalogIndexComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject();
  public catalogs: {
    categoryId: number,
    categoryName: string,
    categoryCode: string,
    productModels: {
      id: number,
      name: string,
      code: string,
      imagePath: string
    }[]
  }[] = [];
  public loaded = false;

  constructor(private catalogService: CatalogService, private router: Router,
              private headerService: HeaderService, private common: CommonService,
              private orderService: OrderService, private navigation: NavigationService) {
  }

  ngOnInit(): void {
    this.headerService.header.next(HeaderStep.HOME);
    this.searchCategories();
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }

  public catalogDetail(categoryId: number): void {
    this.router.navigate(['catalog-detail', String(categoryId)]);
  }

  public modelDetail(modelId: number, categoryId: number): void {
    if (modelId) {
      this.headerService.header.next(HeaderStep.MODEL);
      this.router.navigate(['model-detail-list', String(modelId), String(categoryId)]);
    }
  }

  public productIndex(): void {
    this.router.navigate(['catalog-index']);
  }

  public catalogList(): void {
    this.navigation.goToCatalogList(false);
  }

  private searchCategories(): void {
    this.catalogService.catalogIndex()
      .pipe(takeUntil(this.destroy$))
      .subscribe((data: any) => {
        if (data?.error) {
          this.common.showErrorToast(data?.error);
        } else {
          this.catalogs = data.categories
            .filter((catalog: any) => catalog.productModels.length > 0);
          this.loaded = true;
        }
      });
  }

  public isCopyingConfiguration(): boolean {
    return !!this.orderService.copyConfigurationId;
  }

  public cancelCopyingConfiguration(): void {
    this.orderService.copyConfigurationId = null;
  }

}
